import TextField from 'apollo-react/components/TextField';
import React, { useEffect, useState } from 'react';

import InTableTextArea from '../../form-designer/controls/ssTextArea/InTableTextArea';

const fieldStyles = {
  style: {
    marginTop: 0,
    marginBottom: 'unset',
  },
};

const EditableCell = ({ row, column: { accessor: key } }) => {
  const [value, setValue] = useState(row[key]);
  const [initialValue, setInitialValue] = useState(row[key]);

  useEffect(() => {
    setValue(row[key]);
    setInitialValue(row[key]);
  }, [row, key]);

  const handleUpdateControlValue = (value) => {
    row.editRow(row.id, key, value);
  };

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  const handleBlur = () => {
    if (value !== initialValue) {
      row.editRow(row.id, key, value);
      setInitialValue(value);
    }
  };

  return key === 'query' ? (
    <InTableTextArea
      value={value}
      actions={{ updateControlValue: handleUpdateControlValue }}
      isRequired
      className=""
      id={`${row.id}`}
      entityName=""
      fieldName={key}
      isEditor={false}
      isInComplexGridRow={false}
      paperMaxWidth={1100}
      nuberOfRows={6}
      paperTextFieldWidth={975}
      isRunTimeTranslation={false}
    />
  ) : (
    <TextField
      size="medium"
      fullWidth
      value={value !== null ? value : ''}
      onChange={handleChange}
      onBlur={handleBlur}
      {...fieldStyles}
      required
      asteriskPosition="before"
      style={{ minWidth: 184 }}
      multiline={key === 'query'}
    />
  );
};

export default EditableCell;
